import VendorAdminPartial from "../../../partials/admin/vendors/vendors.admin.partial";

export default function VendorAdminScreen() {
  return <VendorAdminPartial />;
}
